import classNames from "classnames";
import { forwardRef, HTMLAttributes } from "react";

import { LoaderOne, LoaderThree, LoaderTwo, LoaderWrapper } from "./Loader.styled";

export type LoaderProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Set loader color
   *
   * @type {"orange" | "blue" | "green" | "grey" | "red" | "yellow" | "white", | "black"}
   * @default {"orange"}
   */
  color?: "orange" | "blue" | "green" | "grey" | "red" | "yellow" | "white" | "black";

  /**
   * Set loader size
   * @default {"default"}
   *
   * @type {"default" | "small"}
   */
  size?: "default" | "small";
};

const defaultProps: LoaderProps = {
  color: "orange",
  size: "default"
};

const Loader = forwardRef<HTMLDivElement, LoaderProps>((props, ref) => {
  const { className, color, size, ...restProps } = props;
  const loaderClass = classNames("c-loader", className);

  return (
    <LoaderWrapper data-testid="qa-loader" ref={ref} className={loaderClass} {...restProps}>
      <LoaderOne data-testid="qa-loader-dot-one" color={color} size={size} />
      <LoaderTwo data-testid="qa-loader-dot-two" color={color} size={size} />
      <LoaderThree data-testid="qa-loader-dot-three" color={color} size={size} />
    </LoaderWrapper>
  );
});

Loader.defaultProps = defaultProps;

export default Loader;
